"use client";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination,Autoplay,Navigation } from "swiper/modules";


export default function Slider({ children, ...props }: any) {
    return (
        <Swiper
            slidesPerView={1}
            direction="horizontal"
            navigation={true}
            pagination={{ clickable: true }} 
            modules={[Pagination,Autoplay,Navigation]}
            {...props}
        >
            {children?.map((_item: any, index: any) => (
                <SwiperSlide key={_item?.key + index} >
                    {_item.props.children}
                </SwiperSlide>
            ))}
            <div className="swiper-pagination"></div>
        </Swiper>
    );
}

export const SliderItem = SwiperSlide;